import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ErrorHandler,
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { Keychain } from '@awesome-cordova-plugins/keychain/ngx';
import { DeskproChat } from '@freelancer/deskpro-chat';
import { IpBlacklist } from '@freelancer/ip-blacklist';
import { Location } from '@freelancer/location';
import { SecureAndroidStorageService } from '@freelancer/secure-android-storage';
import { UserAgent } from '@freelancer/user-agent';
import { CookieService } from 'ngx-cookie';
import { ADMIN_AUTH_CONFIG, AuthConfig } from './auth.config';
import { Auth } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminAuth extends Auth {
  constructor(
    cookies: CookieService,
    http: HttpClient,
    location: Location,
    userAgent: UserAgent,
    iosKeychain: Keychain,
    errorHandler: ErrorHandler,
    deskproChat: DeskproChat,
    ipBlacklist: IpBlacklist,
    preference: SecureAndroidStorageService,
    @Inject(ADMIN_AUTH_CONFIG) authConfig: AuthConfig,
    @Inject(PLATFORM_ID) platformId: Object,
    @Optional() @Inject(APP_BASE_HREF) baseHref?: string,
  ) {
    super(
      cookies,
      http,
      location,
      userAgent,
      iosKeychain,
      errorHandler,
      deskproChat,
      ipBlacklist,
      preference,
      authConfig,
      platformId,
      baseHref,
    );
  }
}
